import {Component} from '@angular/core';
/**
 * \@title List with sections
 */
export class ListSectionsExample {
  folders = [
    {
      name: 'Photos',
      updated: new Date('1/1/16'),
    },
    {
      name: 'Recipes',
      updated: new Date('1/17/16'),
    },
    {
      name: 'Work',
      updated: new Date('1/28/16'),
    }
  ];
  notes = [
    {
      name: 'Vacation Itinerary',
      updated: new Date('2/20/16'),
    },
    {
      name: 'Kitchen Remodel',
      updated: new Date('1/18/16'),
    }
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'list-sections-example',
  styleUrls: ['list-sections-example.css'],
  templateUrl: 'list-sections-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ListSectionsExample_tsickle_Closure_declarations() {
/** @type {?} */
ListSectionsExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ListSectionsExample.ctorParameters;
/** @type {?} */
ListSectionsExample.prototype.folders;
/** @type {?} */
ListSectionsExample.prototype.notes;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
